import { all, fork } from 'redux-saga/effects';
import { authSaga } from './auth/auth';
import playerSaga from './player';
import moduleSaga from './product/module';
import assetsSaga from './product/assets';
import progressSaga from './product/progress';
import configSaga from './product/config';
import persistSaga from './product/persist';
import searchSaga from './product/search';
import { scormSaga } from './auth/scorm';
import errorSaga from './product/errors';
import { signUpSaga } from './auth/signup';
import { forumSaga } from './admin/forum';

export default function* rootSaga() {
  yield all([
    fork(persistSaga),
    // fork(adminSaga),
    //fork(initialLoadSaga),
    fork(forumSaga),
    fork(authSaga),
    fork(configSaga),
    fork(assetsSaga),
    fork(playerSaga),
    fork(progressSaga),
    fork(moduleSaga),
    fork(searchSaga),
    fork(scormSaga),
    fork(errorSaga),
    fork(signUpSaga),
  ]);
}
